import { CHANGE_ANSWER_ACTION, RESET_ANSWER_ACTION } from '../actions/question';

const makeYesOrNo = ({ label, id, options = ['是', '否'] }) => ({
  ...makeQuestion({ label, id, options }),
  multiple: false,
});

const makeQuestion = ({ label, id, options }) => ({
  id,
  label,
  options,
  exclusiveOption: options.length - 1,
  multiple: true,
  chosen: [],
});

const allQuestions = [
  makeYesOrNo({
    label: '您自己觉得容易疲劳或乏力吗？',
    id: 1,
  }),
  makeQuestion({
    label: '您平时容易怕冷、怕热、或手足心热吗？',
    options: [
      '怕冷(或手脚冰凉)', '怕热', '手足心热', '正常'
    ],
    id: 2,
  }),
  makeQuestion({
    label: '您平时容易出汗或晚上睡觉易出汗吗？ ',
    options: [
      '活动汗出', '夜间出汗', '正常'
    ],
    id: 3,
  }),
  makeQuestion({
    label: '您平时小便怎么样？',
    options: [
      '偏黄', '清长（色清，量多）', '夜尿频多', '正常'
    ],
    id: 4,
  }),
  makeQuestion({
    label: '您平时大便怎么样？',
    options: [
      '偏干', '偏黏', '偏稀(或大便溏)', '正常'
    ],
    id: 5,
  }),
  makeYesOrNo({
    label: '您平时胃口怎么样？',
    id: 6,
    options: ['不好', '正常']
  }),
  makeYesOrNo({
    label: '您平时容易口渴或口干吗？',
    id: 7,
  }),
  makeQuestion({
    label: '您平时觉得口中有异样的味道吗？',
    options: [
      '甜', '苦', '黏', '口淡', '正常'
    ],
    id: 8,
  }),
  makeYesOrNo({
    label: '您平时容易心烦、情绪低落吗？',
    id: 9,
  }),
  makeYesOrNo({
    label: '您容易掉头发吗？',
    id: 10,
  }),
  makeYesOrNo({
    label: '您平时容易失眠吗？',
    id: 11,
  }),
  makeQuestion({
    label: '您平时身体有胀满不适吗？',
    options: [
      '乳房胀', '食后腹胀', '胸胁胀满', '无'
    ],
    id: 12,
  }),
  makeYesOrNo({
    label: '您自己感觉腰膝酸软、腿脚无力吗？',
    id: 13,
  }),
];

const cloneQuestions = function () {
  return allQuestions.map(e => ({ ...e }));
};

const questionInitialState = {
  question: cloneQuestions(),
};

const question = (previousState, action) => {
  let state = { ...previousState };
  switch (action.type) {
    case CHANGE_ANSWER_ACTION: {
      const { id, chosen } = action;
      findQuestion(state, { id }).chosen = [...chosen];
      break;
    }
    case RESET_ANSWER_ACTION: {
      state = cloneQuestions();
      break;
    }
    default:
      break;
  }
  return state;
};

const findQuestion = (state, props) => (
  Object.values(state.question || state).find(q => q.id === props.id)
);
const questionProp = (state, props, field) => findQuestion(state, props)[field];

export { question, questionInitialState, findQuestion, questionProp };



// WEBPACK FOOTER //
// ./src/reducers/question.js